<app-header [forceLightBackground]="true"></app-header>
<div class="challenge-home">
  <div class="challenge-home--layout">
    <app-admin-sidebar class="challenge-home--sidebar"></app-admin-sidebar>
    <div class="challenge-home--content">
      <app-page-header></app-page-header>
      <div class="challenge-container">
        <!-- Tabs -->
        <div class="challenge-tabs">
          <div class="challenge-tabs--left">
            <button
              class="challenge-tabs--tab"
              [class.active]="activeTab === 'create'"
              (click)="setTab('create')"
              type="button"
            >
              <span class="challenge-tabs--text-full">Create</span>
              <span class="challenge-tabs--text-short">Create</span>
            </button>
            <button
              class="challenge-tabs--tab"
              [class.active]="activeTab === 'scheduled'"
              (click)="setTab('scheduled')"
              type="button"
            >
              <span class="challenge-tabs--text-full">Scheduled</span>
              <span class="challenge-tabs--text-short">Scheduled</span>
            </button>
            <button
              class="challenge-tabs--tab"
              [class.active]="activeTab === 'running'"
              (click)="setTab('running')"
              type="button"
            >
              <span class="challenge-tabs--text-full">Running</span>
              <span class="challenge-tabs--text-short">Running</span>
            </button>
            <button
              class="challenge-tabs--tab"
              [class.active]="activeTab === 'evaluation'"
              (click)="setTab('evaluation')"
              type="button"
            >
              <span class="challenge-tabs--text-full">Evaluation</span>
              <span class="challenge-tabs--text-short">Evaluation</span>
            </button>
            <button
              class="challenge-tabs--tab"
              [class.active]="activeTab === 'completed'"
              (click)="setTab('completed')"
              type="button"
            >
              <span class="challenge-tabs--text-full">Completed</span>
              <span class="challenge-tabs--text-short">Completed</span>
            </button>
          </div>
          <!-- My Drafts Button - Only show when Create Challenge tab is active -->
          <div class="challenge-tabs--right">
            <button
              *ngIf="activeTab === 'create'"
              class="challenge-tabs--drafts-btn"
              (click)="openDraftsModal()"
              type="button"
            >
              My Drafts
            </button>
          </div>
        </div>

        <!-- Tab Content (lazy-loaded via router) -->
        <div class="challenge-tab-content">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>